module.exports = __webpack_public_path__ + "img/side_industries.d814d141.png";